import PasswordCreationForm from 'components/passwordCreationForm';
import './PasswordSection.scss';
import { useTranslation } from 'react-i18next';
import { Progress } from 'antd';

interface PasswordSectionProps {
  isHidden?: boolean;
  phoneNumber?: string;
}

const PasswordSection: React.FC<PasswordSectionProps> = ({
  isHidden = false,
  phoneNumber = '',
}) => {
  const { t } = useTranslation('registration');

  return (
    <div className="password-section-container" style={{ display: isHidden ? 'none' : 'flex' }}>

      <div className="vls-section-title">{t('welcomeTitle')}</div>

      <Progress
        percent={30}
        showInfo={false}
        className="registration-progress"
      />

      <div className="vls-section-title">{t('passwordCreation.title')}</div>

      <PasswordCreationForm />
    </div>
  );
};

export default PasswordSection;
